import webBackApi, { WEBBACK_URL } from '../../api/webBackApi';

export { WEBBACK_URL };

export const fetchRemainingImages = async (feedId, customerId) => {
  try {
    const response = await webBackApi.post(`/api/v1/teleport/fetch-remaining-images?feedId=${feedId}&customerId=${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching remaining images:", error);
    throw error;
  }
};
